module.exports = __webpack_public_path__ + "631472b88833dbde97fdea5bf8773415.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/main/img/neu/familie-mit-zwei-kindern-neu.svg
// module id = 136
// module chunks = 1